import { Box, Button } from "@mui/material";
import RemoteCombo, { RemoteComboProps, configureSuggestStore } from "../../components/form/RemoteCombo";
import { useCachedStore } from "../../models/Hooks";
import { House } from "../../models/Types";
import { HouseForm } from "./HouseForm";
import { hasKey } from "../../models/Identity";

const cmd = 'HouseSuggest';
const valueField = 'Name';

export const houseStore = configureSuggestStore<House>(cmd, valueField, 30 * 60, ['HouseSave']);

export default function HouseCombo({ name, value, onDataLoad, filter, onChange, allowAdd, multiple, selectFirstOnLoad, disabled, ...props }: RemoteComboProps<House>) {
    if (!hasKey('House')) {
        allowAdd = false;
    }

    return <RemoteCombo<House>
        name={name}
        store={houseStore}
        typeId="House"
        allowAdd={allowAdd}
        value={value}
        multiple={multiple}
        onDataLoad={onDataLoad}
        selectFirstOnLoad={selectFirstOnLoad}
        filter={filter}
        onChange={onChange}
        disabled={disabled}
        createComponent={allowAdd === false ? null : onClose => <HouseForm id={0} onlyRequired={true} onClose={onClose} apiRef={api => api?.onSave((id, e) => {
            onClose(e);
            return false;
        })} sx={{ p: 2 }} />}
    />;
}

export function HouseToggle({ name, value, onDataLoad, filter, onChange, allowAdd, multiple, selectFirstOnLoad }: RemoteComboProps<House>) {
    const [data] = useCachedStore(houseStore, d => {
        onDataLoad && onDataLoad(d);
        if (onChange && selectFirstOnLoad && !value && d?.length) {
            onChange({
                target: {
                    name,
                    value: parseInt(d[0].Id)
                }
            })
        }
    });

    return <Box sx={{ display: 'flex', gap: 1, overflow: 'auto' }}>
        {data?.filter(x => !filter || filter(x)).map(x => <Button
            key={x.Id}
            name={name}
            value={x.Id}
            onClick={e => onChange({
                target: {
                    name,
                    value: parseInt(e.target.value)
                }
            })}
            color={value == x.Id ? 'primary' : 'secondary'}
            variant="outlined"
            sx={{
                textWrap: 'nowrap',
                overflow: 'hidden',
                flex: 'none'
            }}
        >
            {x.Value}
        </Button>)}
    </Box>;
}